<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body text-center">
              <feather
                type="cpu"
                size="50px"
              />
              <h3>{{ $t('underConstruction.shifHazrlanmaMrhlsinddir') }}</h3>
              <p>
                {{ $t('underConstruction.axtardnzShifMvcudDeyilVYaHazrlanmaMrhlsinddir') }}
              </p>
              <p>
                <router-link
                  class="btn btn-sm btn-outline-primary"
                  :to="{name: 'welcome'}"
                >
                  {{ $t('underConstruction.lvhyKe') }}
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>

    export default {
        data() {
            return {}
        },

        mounted() {


        }

    }
</script>
<style>
    div.review canvas {
        position: relative !important;
    }

    div.review input {
        z-index: 1;
        display: inline-block;
    }
</style>
